import React from 'react'

export default function Learn() {
  return (
    <>
    <h1 className='items-center flex justify-center p-20 h-screen'>Comming soon ..</h1>
    </>
  )
}
